import type { Components } from '@mui/material/styles';
import { tabClasses } from '@mui/material/Tab';
import { tabsClasses } from '@mui/material/Tabs';

import type { Theme } from '../types';

export const MuiTabs = {
  styleOverrides: {
    root: { minHeight: 'auto' },
    flexContainer: {
      [`&:not(.${tabsClasses.flexContainerVertical})`]: {
        gap: '4px',
        width: 'fit-content',
        padding: '4px',
        border: '1px solid var(--mui-palette-divider)',
        borderRadius: '10px',
        backgroundColor: 'var(--mui-palette-background-level1)',
      },
    },
    indicator: { display: 'none' },
    vertical: {
      [`& .${tabsClasses.indicator}`]: {
        display: 'none',
      },
      [`& .${tabsClasses.flexContainer}`]: {
        width: '100%',
        gap: '4px',
        padding: 0,
        border: 'none',
        backgroundColor: 'transparent',
      },
      [`& .${tabClasses.root}`]: {
        justifyContent: 'flex-start',
        paddingInline: '12px',
      },
    },
  },
} satisfies Components<Theme>['MuiTabs'];
